import './ThankYou.scss'
import React from 'react';

export default function Donate() {

    return (
        <div>
            <div className='container font-format ' style={{ margin: 'auto', paddingTop: '5vh' }}>

                <h1 className='givingTitle'>Thank You!</h1>

                <div className='givingText'>
                    <br />
                    <p>
                        Your generosity is changing lives. We truly appreciate your continued support towards Jasmine Rhose Foundation.
                        <br></br>
                        <br></br>
                        Together we can "Defend the poor and the fatherless; do justice to the afflicted and needy." Psalm 82:3
                    </p>





                    <br />
                    <br />





                </div>

            </div>
        </div>

    );
}